export default {
  title: "Всички визити",
  subtitle: "Преглед и управление на всички визити на пациенти",
  comingSoon: "Очаквайте скоро",
  description:
    "Тази функция ще ви позволи да преглеждате и управлявате всички визити на пациенти на едно място.",
  copied: "Копирано в клипборда",
  gender: {
    male: "Мъж",
    female: "Жена",
  },
  actions: {
    filter: "Филтриране на визити",
    refresh: "Обновяване",
    viewResults: "Преглед на резултати",
    downloadPdf: "Изтегляне на резултатите като PDF",
  },
  table: {
    id: "ID",
    idTooltip: "Номер на визита",
    copyId: "Копиране на номера на визита",
    date: "Дата / Час",
    dateTooltip: "Дата и час на визита",
    pid: "ЕГН",
    patient: "Пациент",
    readiness: "Готовност",
    readinessTooltip: "{percent}% готово",
    flags: "Флагове",
    actionsTitle: "Действия",
    flagsTooltipSingular: "Съкратен преглед - {count} флагиран",
    flagsTooltipPlural: "Съкратен преглед - {count} флагирани",
    openRecord: "Преглед на досие на пациент",
    test: "Изследване",
    result: "Резултат",
    flag: "Флаг",
    units: "Единици",
    refRange: "Реф. диапазон",
    itemsPerPage: "Елементи на страница",
  },
  preview: {
    toggle: "Преглед",
    newTab: "в нов таб",
    currentTab: "в текущ таб",
  },
  filters: {
    title: "Филтриране на визити",
    subtitle: "Задайте условия за стесняване на списъка с визити",
    field: "Поле",
    fieldPlaceholder: "Изберете поле",
    fieldHint: "Поле от визита за филтриране",
    fieldRequired: "Изберете поле",
    operator: "Тип съвпадение",
    operatorHint: "Начин на сравняване на данните",
    operatorRequired: "Изберете тип",
    value: "Стойност",
    valuePlaceholder: "Въведете стойност",
    valueHint: "Стойност за търсене във визитите",
    valueRequired: "Въведете стойност",
    add: "Добавяне на условие",
    addAnother: "Добавяне на условие",
    addFirst: "Добавяне на първо условие",
    apply: "Прилагане на филтри",
    save: "Запазване",
    clearAll: "Изчистване на всички",
    andConnector: "И",
    emptyTitle: "Няма добавени условия",
    emptyDescription: "Добавете условия за филтриране, за да стесните визитите в таблицата.",
    empty: "Няма филтри. Добавете един, за да стесните списъка.",
    preview: "FQL преглед",
    fqlPreviewBtn: "Показване на FQL",
    fqlPreviewTitle: "FQL заявка",
    removeRow: "Премахване на условие",
    clearAllTooltip: "Премахване на всички условия",
    addFilterTooltip: "Добавяне на ново условие",
    fields: {
      givenName: "Име",
      middleName: "Презиме",
      familyName: "Фамилия",
      patientId: "ЕГН",
      gender: "Пол",
      dateOfBirth: "Дата на раждане",
      date: "Дата на визита",
    },
    operators: {
      cn: "Съдържа",
      sw: "Започва с",
      ew: "Завършва с",
      eq: "Равно на",
    },
    booleanValues: {
      true: "Мъж",
      false: "Жена",
    },
    fieldHints: {
      givenName: "Собствено (първо) име на пациента",
      middleName: "Бащино (средно) име на пациента",
      familyName: "Фамилно (последно) име на пациента",
      patientId: "Единен граждански номер (ЕГН)",
      gender: "Биологичен пол на пациента",
      dateOfBirth: "Формат: YYYY-MM-DD",
      date: "Формат: YYYY-MM-DD",
    },
  },
  dialogs: {
    errors: {
      serverTitle: "Нещо се обърка",
      serverSubtitle: "Неуспешно зареждане на данните. Моля, опитайте отново.",
      networkTitle: "Загубена връзка",
      networkSubtitle: "Няма връзка със сървъра. Проверете интернет връзката си.",
      timeoutTitle: "Времето за изчакване изтече",
      timeoutSubtitle:
        "Заявката не бе обработена навреме. Вероятно е временен проблем — опитайте отново след малко.",
      authTitle: "Сесията изтече",
      authSubtitle: "Моля, влезте отново.",
      unknownTitle: "Неочаквана грешка",
      unknownSubtitle: "Нещо се обърка. Моля, опитайте по-късно.",
      retry: "Повторен опит",
      login: "Вход",
    },
    results: {
      title: "Резултати от визита",
      subtitle: "Номер на визита:",
      empty: "Няма намерени резултати",
      emptySubtitle: "Няма резултати за показване в тази визита.",
      history: "Виж история на изследването",
      loading: "Зареждане на резултати от визита\u2026",
    },
    flags: {
      title: "Флагирани резултати",
      subtitle: "{count} флагирани резултати",
      loading: "Зареждане на флагирани резултати\u2026",
    },
  },
  errors: {
    serverTitle: "Нещо се обърка",
    serverSubtitle: "Неуспешно зареждане на визитите. Моля, опитайте отново.",
    networkTitle: "Загубена връзка",
    networkSubtitle: "Няма връзка със сървъра. Моля, проверете интернет връзката си.",
    timeoutTitle: "Времето за изчакване изтече",
    timeoutSubtitle:
      "Заявката не бе обработена навреме. Вероятно е временен проблем — опитайте отново след малко.",
    authTitle: "Сесията изтече",
    authSubtitle: "Моля, влезте отново.",
    validationTitle: "Невалиден филтър",
    validationSubtitle: "Филтърът не може да бъде обработен. Моля, коригирайте и опитайте отново.",
    unknownTitle: "Неочаквана грешка",
    unknownSubtitle: "Нещо се обърка. Моля, опитайте по-късно.",
    emptyTitle: "Няма намерени визити",
    emptySubtitle: "В системата все още няма регистрирани визити.",
    filteredEmptyTitle: "Няма съвпадащи визити",
    filteredEmptySubtitle: "Няма визити, отговарящи на текущите филтри.",
    retry: "Повторен опит",
    clearFilters: "Изчистване на филтрите",
    editFilters: "Промяна на филтрите",
    login: "Вход",
    refreshFailed: "Неуспешно обновяване \u2014 показват се последните известни резултати.",
  },
};
